module.exports = __webpack_public_path__ + "static/media/delete_logo.9f9bb223.png";